import React from 'react'
import '../App.css'

export default function ErrorToast({
  message,
} : {
  message: string | null;
}) {

  if (!message) {
    return null;
  }

  return (
    // Error Toast in bottom right corner
    <div className="blank-full-screen">
      <div className="toast-container">
        <div className="toast-body">
          <b>Error!</b>
          {message}
        </div>
      </div>
    </div>
  )
}
